import { useState, useEffect } from 'react';
import { Clock } from 'lucide-react';
import { cn } from '@/lib/utils';

export type ClockSize = 'sm' | 'md' | 'lg';

interface LimaClockProps {
  size?: ClockSize;
  className?: string;
}

export const LimaClock = ({ size = 'sm', className }: LimaClockProps) => {
  const [time, setTime] = useState<string>('');

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      // Lima is UTC-5 (no daylight saving time)
      const limaTime = new Date(now.toLocaleString('en-US', { timeZone: 'America/Lima' }));
      const hours = limaTime.getHours().toString().padStart(2, '0');
      const minutes = limaTime.getMinutes().toString().padStart(2, '0');
      const seconds = limaTime.getSeconds().toString().padStart(2, '0');
      setTime(`${hours}:${minutes}:${seconds}`);
    };

    updateTime();
    const interval = setInterval(updateTime, 1000);
    return () => clearInterval(interval);
  }, []);

  const sizeClasses = {
    sm: {
      container: 'gap-2',
      icon: 'h-4 w-4',
      time: 'text-sm',
      label: 'text-xs',
    },
    md: {
      container: 'gap-3',
      icon: 'h-6 w-6',
      time: 'text-2xl',
      label: 'text-sm',
    },
    lg: {
      container: 'gap-4',
      icon: 'h-8 w-8',
      time: 'text-4xl',
      label: 'text-base',
    },
  };

  const classes = sizeClasses[size];

  return (
    <div className={cn(
      'flex items-center justify-center text-muted-foreground',
      classes.container,
      className
    )}>
      <Clock className={classes.icon} />
      <span className={cn('font-mono font-semibold', classes.time)}>
        {time}
      </span>
      <span className={classes.label}>
        Lima, Perú
      </span>
    </div>
  );
};
